(function () {
	const scrollTop = () => {
		const btnScrollTop = document.querySelector(".scroll-top");
		let ticking = false;
		window.addEventListener("scroll", function () {
			if (!btnScrollTop || ticking) return;
			ticking = true;
			requestAnimationFrame(function () {
				if (scrollY > document.documentElement.clientHeight) {
					btnScrollTop.classList.add("show");
				} else {
					btnScrollTop.classList.remove("show");
				}
				ticking = false;
			});
		}, { passive: true });

		btnScrollTop.onclick = () => {
			window.scrollTo({ top: 0, behavior: "smooth" });
		};
	};

	scrollTop();

	document.addEventListener("shopify:section:load", function () {
		scrollTop();
	});
})();
